// @flow

import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

import COLORS from 'client/constants/colors';

type ColorType =
  | 'blueHighlight'
  | 'greenHighlight'
  | 'navyHighlight'
  | 'orangeHighlight'
  | 'purpleHighlight'
  | 'redHighlight';

export type HighlightHeaderType = {
  text: string,
  [key: ColorType]: Array<string>,
};

const COLOR_TYPES = {
  BLUE: 'blueHighlight',
  GREEN: 'greenHighlight',
  NAVY: 'navyHighlight',
  ORANGE: 'orangeHighlight',
  PURPLE: 'purpleHighlight',
  RED: 'redHighlight',
};

const colorMapping = [
  COLOR_TYPES.BLUE,
  COLOR_TYPES.GREEN,
  COLOR_TYPES.NAVY,
  COLOR_TYPES.ORANGE,
  COLOR_TYPES.PURPLE,
  COLOR_TYPES.RED,
];

const HighlightWrapper = styled.span`
  .blueHighlight {
    color: ${COLORS.BLUE_1};
  }
  .redHighlight {
    color: ${COLORS.RED_2};
  }
  .greenHighlight {
    color: ${COLORS.GREEN_0};
  }
  .purpleHighlight {
    color: ${COLORS.PURPLE_2};
  }
  .navyHighlight {
    color: ${COLORS.NAVY_1};
  }
  .orangeHighlight {
    color: ${COLORS.ORANGE_1};
  }
`;

const HighlightHeader = (props: HighlightHeaderType) => {
  const { text } = props;
  let header = text;
  _.forEach(colorMapping, (colorType) => {
    if (!_.isEmpty(props[colorType])) {
      _.forEach(props[colorType], (words) => {
        const highlight = `<span class="${colorType}">${words}</span>`;
        header = header.replace(words, highlight);
      });
    }
  });

  return <HighlightWrapper dangerouslySetInnerHTML={{ __html: header }} />;
};

export default HighlightHeader;
